import React from "react";

import { Schema as ISchema } from "@/types/SEO";
import { CleanupRawSchema } from "./CleanupRawSchema";


const Schema = ({ isFrontPage = false, schema, featuredImage = '', skipParsingSchema }: {
  schema?: ISchema,
  isFrontPage?: boolean,
  featuredImage?: string,
  skipParsingSchema: boolean
}): JSX.Element | null => {

  const schemaContext = skipParsingSchema ? schema?.raw : 
    CleanupRawSchema(isFrontPage ?? false, schema?.raw, featuredImage);

  if (!schemaContext) {
    return null;
  }

  return (
    <script type="application/ld+json">{schemaContext}</script>
  );
};

export default Schema;
